import { render } from "./advisorTokenAdvice.vue?vue&type=template&id=17ff0c18&scoped=true&ts=true"
import script from "./advisorTokenAdvice.vue?vue&type=script&lang=ts"
export * from "./advisorTokenAdvice.vue?vue&type=script&lang=ts"

import "./advisorTokenAdvice.vue?vue&type=style&index=0&id=17ff0c18&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17ff0c18"]])

export default __exports__